import { FC } from "react";
import { useTranslation } from "react-i18next";
import { WorkDTO } from "../../../../domain/models/dto/WorkDTO";
import { WorkStatus } from "../../../../domain/enums/WorkStatusEnum";
import { isWorkConsideredNew } from "../../../../slices/works-slice";
import { ApplicationStatus } from "../../../../domain/enums/ApplicationStatusEnum";

interface WorkStatusLabelProps {
    work: WorkDTO;
    biggerVersion?: boolean;
    showPersonalApplicationStatus?: boolean;
}

export const getWorkStatusTranslationKey = (
    work: WorkDTO,
    showPersonalApplicationStatus = false
) => {
    if (
        !showPersonalApplicationStatus ||
        work.status === WorkStatus.DONE ||
        work.status === WorkStatus.DELETED
    ) {
        return `work.statuses.${work.status}`;
    }

    switch (work.userApplication?.status) {
        case ApplicationStatus.APPROVED:
            return "work.applicationStatuses.selected";
        case ApplicationStatus.DECLINED:
            return "work.applicationStatuses.rejected";
        case ApplicationStatus.IN_REVIEW:
            return "work.applicationStatuses.pending";
        default:
            return `work.statuses.${work.status}`;
    }
};

const WorkStatusLabel: FC<WorkStatusLabelProps> = (props) => {
    const { t } = useTranslation();
    const isWorkNew = isWorkConsideredNew(props.work);
    const statusTranslationKey = getWorkStatusTranslationKey(
        props.work,
        props.showPersonalApplicationStatus
    );
    const getWorkStatusColor = () => {
        switch (props.work.status) {
            case WorkStatus.ACTIVE:
                return "bg-accentGreen";
            case WorkStatus.STAFFED:
                return "bg-textWarning";
            case WorkStatus.DONE:
                return "bg-backgroundButton";
            case WorkStatus.DELETED:
                return "bg-backgroundButton";
            default:
                return "bg-backgroundButton";
        }
    };

    return (
        <>
            {props.biggerVersion ? (
                <>
                    {isWorkNew && (
                        <div className="flex justify-center items-center bg-primaryBlue rounded-[30px] h-[38px] dmax2:h-[26px] px-9 dmax2:px-5">
                            <span className="H20 dmax2:H14 text-textWhite">{t("work.statuses.new")}</span>
                        </div>
                    )}
                    <div
                        className={`${getWorkStatusColor()} flex justify-center items-center rounded-[30px] h-[38px] dmax2:h-[26px] px-9 dmax2:px-5`}
                    >
                        <span className="H20 dmax2:H14 text-textWhite">{t(statusTranslationKey)}</span>
                    </div>
                </>
            ) : (
                <>
                    {isWorkNew && (
                        <div className="flex justify-center items-center bg-primaryBlue rounded-[30px] h-[31px] dmax2:h-6 px-[30px] dmax2:px-5">
                            <span className="H20 dmax2:H14 text-textWhite">{t("work.statuses.new")}</span>
                        </div>
                    )}
                    <div
                        className={`${getWorkStatusColor()} flex justify-center items-center rounded-[30px] h-[31px] dmax2:h-6 px-[30px] dmax2:px-5`}
                    >
                        <span className="H20 dmax2:H14 text-textWhite">{t(statusTranslationKey)}</span>
                    </div>
                </>
            )}
        </>
    );
};

export default WorkStatusLabel;
